import { ShoppingBag, ArrowRight } from "lucide-react";
import { useInquiry } from "../context/InquiryContext";
import { motion, AnimatePresence } from "framer-motion";

export const FloatingInquiryBar = () => {
  const { totalCount, totalPrice, isModalOpen, openInquiry } = useInquiry();

  // If modal is open or no items, don't show the floating bar
  if (totalCount === 0 || isModalOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 50, opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="fixed bottom-5 right-5 z-40"
      >
        <button
          type="button"
          onClick={() => openInquiry()}
          className="flex items-center gap-3 bg-slate-900 hover:bg-orange-600 text-white pl-4 pr-5 py-3 shadow-2xl transition-all hover:scale-105 active:scale-95 group cursor-pointer border border-slate-700/50"
          aria-label="Åbn samlet produktforespørgsel"
        >
          <div className="relative flex items-center justify-center">
            <ShoppingBag size={20} />
            <span className="absolute -top-2 -right-2 bg-orange-500 group-hover:bg-slate-900 text-white text-[10px] font-bold w-5 h-5 rounded-full flex items-center justify-center border-2 border-slate-900 transition-colors">
              {totalCount}
            </span>
          </div>
          <div className="text-left leading-tight">
            <span className="text-[11px] font-bold uppercase tracking-wider block text-orange-400 group-hover:text-orange-200 transition-colors">
              Forespørgsel ({totalCount})
            </span>
            <span className="text-xs font-mono font-bold block">
              {totalPrice}
            </span>
          </div>
          <ArrowRight
            size={14}
            className="ml-1 text-slate-400 group-hover:text-white transition-colors group-hover:translate-x-0.5"
          />
        </button>
      </motion.div>
    </AnimatePresence>
  );
};
